export enum WebsiteType {
	BANK_OF_IRELAND = "BANK_OF_IRELAND"
}

export enum WebsiteTheme {
	boi = "boi",
	nevo = "nevo"
}